import { Stack } from '@mui/material';
import BaseInput from '@mui/material/InputBase';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)``;
export const Input = styled(BaseInput)``;
export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
